/**
 * @generated SignedSource<<24270a7124ce9c12b8791b1f5dc6eb92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoleDeleteMutation$variables = {
  id: number;
};
export type RoleDeleteMutation$data = {
  readonly deleteRole: {
    readonly account: {
      readonly id: number;
      readonly roles: ReadonlyArray<{
        readonly id: number;
      }>;
    } | null | undefined;
  };
};
export type RoleDeleteMutation = {
  response: RoleDeleteMutation$data;
  variables: RoleDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoleDeletedResult",
    "kind": "LinkedField",
    "name": "deleteRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "roles",
            "kind": "LinkedField",
            "name": "roles",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoleDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoleDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f631507a3ae7fdab23ccdd15a32853e1",
    "id": null,
    "metadata": {},
    "name": "RoleDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation RoleDeleteMutation(\n  $id: Int!\n) {\n  deleteRole(id: $id) {\n    account {\n      id\n      roles {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fad17e781e687642cec909b7e93fc437";

export default node;
